import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { FeatureIdentifier } from '../enums/feature-identifier.enum';
import { SubscriptionPaymentType } from '../enums/subscription-payment-type.enum';
import { Coupon } from '../models/coupon.model';
import { Module, Plan } from '../models/plan.model';
import { Subscription } from '../models/subscription.model';
import { RequestService } from './request.service';

@Injectable()
export class SubscriptionService {

	constructor(private requestService: RequestService) { }

	async getPlans(onlyVisible: boolean): Promise<Array<Plan>> {
		const response: Array<any> = await this.requestService.getData(APP_CONFIG.WEBSERVICE.GET_ACTIVE_PLANS);
		console.log(response);
		const plans: Array<Plan> = [];
		if (response && response.length > 0) {
			response.forEach((p: Plan) => {
				if (!onlyVisible || p.visible) {
					plans.push(new Plan(p));
				}
			});
		}
		return plans;
	}

	async getSubscription(storeId: number): Promise<Subscription> {
		const response: Subscription = await this.requestService.getData(APP_CONFIG.WEBSERVICE.SUBSCRIPTION + "/" + storeId);
		return response ? new Subscription(response) : response;
	}

	async subscribe(storeId: number, selectedPlan: Plan, paymentType: SubscriptionPaymentType, coupon: Coupon): Promise<any> {
		const data: any = {
			store: { id: storeId },
			plan: { id: selectedPlan.id },
			paymentType: paymentType
		};
		const extras: Array<number> = selectedPlan.extraModules.filter((m) => m.selected).map((m) => m.id);
		if (extras && extras.length > 0) {
			data.extraModulesId = extras;
		}
		if (coupon) {
			data.coupon = coupon.code;
		}
		const response: any = await this.requestService.postData(APP_CONFIG.WEBSERVICE.ACTIVE_SUBSCRIPTION, data);
		console.log(response);
		return response;
	}

	async cancelSubscribe(storeId: number): Promise<void> {
		const response: Array<any> = await this.requestService.postData(APP_CONFIG.WEBSERVICE.CANCEL_SUBSCRIBE + storeId);
		console.log(response);
	}

	async reactivateSubscription(storeId: number): Promise<void> {
		const data: any = {
			store: { id: storeId }
		};
		const response: Array<any> = await this.requestService.postData(APP_CONFIG.WEBSERVICE.REACTIVATE_SUBSCRIPTION, data);
		console.log(response);
	}

	async changeSubscription(storeId: number, selectedPlan: Plan, coupon: Coupon): Promise<void> {
		const data: any = {
			store: { id: storeId },
			plan: { id: selectedPlan.id }
		};
		const extras: Array<number> = selectedPlan.extraModules.filter((m) => m.selected).map((m) => m.id);
		if (extras && extras.length > 0) {
			data.extraModulesId = extras;
		}
		if (coupon) {
			data.coupon = coupon.code;
		}
		const response: Array<any> = await this.requestService.putData(APP_CONFIG.WEBSERVICE.SUBSCRIPTION, data);
		console.log(response);
	}

	async changePaymentType(storeId: number, paymentType: SubscriptionPaymentType): Promise<void> {
		const data: any = {
			store: { id: storeId },
			paymentType: paymentType
		};
		await this.requestService.putData(APP_CONFIG.WEBSERVICE.SUBSCRIPTION_PAYMENT_TYPE, data);
	}

	async startTestModules(subscriptionId: number, planId: number, modules: Module[]): Promise<void> {
		const data: any = {
			modules: modules.map((m) => {
				return { id: m.id }
			})
		};
		console.log(data);
		const urlRequest: string = this.requestService.buildUrlPathParams({ id: subscriptionId }, APP_CONFIG.WEBSERVICE.START_TEST_MODULES);
		await this.requestService.postData(urlRequest, data);
	}

	validateModuleRequirement(module: Module, selectedPlan: Plan): void {
		switch (module.featureIdentifiers) {
			case FeatureIdentifier.MENU:
				// Se estiver desmarcando o módulo de cardápio, verifica se não tem um módulo dependente
				if (!module.selected) {
					selectedPlan.extraModules.forEach((m) => {
						if (m.selected) {
							if ([FeatureIdentifier.FULL_ORDER, FeatureIdentifier.MULTI_LANG].indexOf(m.featureIdentifiers) != -1) {
								m.selected = false;
							}
						}
					})
				}
				break;
			
			case FeatureIdentifier.FULL_ORDER:
			case FeatureIdentifier.MULTI_LANG:
				// Verifica se o módulo de cardápio que é requisito está selecionado
				let menuIndex = selectedPlan.extraModules.findIndex(m => m.featureIdentifiers == FeatureIdentifier.MENU);
				if (menuIndex > -1 && !selectedPlan.extraModules[menuIndex].selected) {
					selectedPlan.extraModules[menuIndex].selected = true;
				}
				break;

			default:
				break;
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/services/subscription.service.ts